import { CloseOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, DatePicker, Form, Input, InputNumber, Modal, Select } from "antd";

import viVN from 'antd/locale/vi_VN';

import { FormProps } from "antd/lib";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getInfoCarCustomer } from "../../../../../../api/car/carApi";
import { editServiceSalesCare, InfoServiceSalesCare } from "../../../../../../api/Customer_V2/customerApi_V2";
import { getSLCarsByCarLineIdAndCategoryCarId } from "../../../../../../api/selectOption/selectOptionsApi";
import { getSLVehicleEngineNos, ISelectOption } from "../../../../../../api/selectOptions/selectOptionsApi";
import useDebounce from "../../../../../../hook/useDebounce";
import useLoading from "../../../../../../hook/useLoading";
import useThrottle from "../../../../../../hook/useThrottle";
import useToast from "../../../../../../hook/useToast";
import { dataInteractionCategory, dataInteractionCategory_V2 } from "../../../../../../services/data";
import { selectorInfoUser } from "../../../../../../store/slices/infoUserSlice";
import { selectorUnitByUserPermission } from "../../../../../../store/slices/UnitByUserPermission";
import { convertToAntdOptions, fommatSelectOptionToUpperCase, fommatSelectOptionUnitByUser, mapDocCode } from "../../../../../../until";
import '../../../../styles.scss';
const { TextArea } = Input;

interface ModalProps {
    isOpen: boolean
    idCustomer?: number
    infoModalSalesAndService?: InfoServiceSalesCare
    closeModal: (isOpen: boolean) => void
    resultFormSubmit?: (iSsuccess: boolean, message?: string) => void
}
const ModalSalesAndServiceUpdate: React.FC<ModalProps> = ({
    isOpen, idCustomer,
    infoModalSalesAndService,
    resultFormSubmit, closeModal
}) => {
    const pushToast = useToast()
    const pushLoading = useLoading()
    const { id, username, unit } = useSelector(selectorInfoUser)
    const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)
    const [form] = Form.useForm();

    const isProgrammaticCarLineSet = React.useRef(true);
    const isProgrammaticPlate = React.useRef(true);
    const isProgrammaticChassisNo = React.useRef(true);

    const vehicleId = Form.useWatch("vehicleId", form); // tên xe
    // const numberPlateId = Form.useWatch("numberPlateId", form); // biển số
    const chassisNo = Form.useWatch("chassisNo", form); // số khung

    const [sLCarId, setSLCarId] = useState<any[]>([])
    const [sLNumberPlateId, setSLNumberPlateId] = useState<ISelectOption[]>([])
    const [sLChassisNo, setSLChassisNo] = useState<ISelectOption[]>([])
    const [sLEngineNo, setSLEngineNo] = useState<ISelectOption[]>([])

    const [sLAdminId, setSLAdminId] = useState<ISelectOption[]>([{ value: id, label: username }])
    const [sLBranchId, setSLBranchId] = useState<ISelectOption[]>([])

    const [searchCar, setSearchCar] = useState<string>('')

    const [carId, setCarId] = useState<number>()
    const [plateNumberId, setPlateNumberId] = useState<number>()
    //#region gọi api SL OP
    // tên xe
    const gSLCarId = useDebounce(async () => {
        if (!idCustomer) return
        const result = await getSLCarsByCarLineIdAndCategoryCarId(
            idCustomer, undefined, undefined, searchCar
        )
        if (result?.status) {
            setSLCarId(convertToAntdOptions(result.data))
        }
    }, 1000)

    const gInfoCarCustomer = useDebounce(async () => {
        if (!idCustomer || !vehicleId) return
        const result = await getInfoCarCustomer(
            vehicleId, idCustomer
        )
        if (result?.status) {
            const { plateNumber, plateNumberId, vehicleChassisNo } = result.data
            setSLChassisNo(fommatSelectOptionToUpperCase(vehicleChassisNo))
            form.setFieldValue("numberPlateId", plateNumber);
            setPlateNumberId(plateNumberId)
            if (vehicleChassisNo.length === 1)
                form.setFieldValue("chassisNo", vehicleChassisNo[0].id);
        }
    }, 1000)

    // số máy
    const gSLEngineNo = async () => {
        if (!idCustomer) return
        if (!chassisNo) {
            setSLEngineNo([])
            return
        }
        const result = await getSLVehicleEngineNos(
            idCustomer, vehicleId,
        )
        if (result?.status) {
            setSLEngineNo(fommatSelectOptionToUpperCase(result.data))

            if (result.data.length === 1) {
                const { id } = result.data[0]
                form.setFieldValue("engineNo", id); // Số máy
            }
        }
    }

    //dơn vị
    const gSLBranchId = async () => {
        setSLBranchId(fommatSelectOptionUnitByUser(unitByUserPermissionSlice))
    }
    //#endregion


    const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {
        if (!idCustomer) return
        pushLoading(true)

        const {
            vehicleBookingDocCode, registrationDate,
            contactType, vehicleId,  chassisNo,
            engineNo, currentMileageKm, maintenanceReminderDate, adminId,
            branchId, vehicleBookingDescription
        } = values

        const registrationDateTmp = registrationDate ? registrationDate?.format('YYYY/MM/DD') : undefined
        const maintenanceReminderDateTmp = maintenanceReminderDate ? maintenanceReminderDate?.format('YYYY/MM/DD') : undefined

        const result = await editServiceSalesCare(
            infoModalSalesAndService?.id || 0, idCustomer, vehicleBookingDocCode, registrationDateTmp,
            contactType, carId, vehicleId, plateNumberId, chassisNo,
            engineNo, currentMileageKm, maintenanceReminderDateTmp, adminId,
            branchId, vehicleBookingDescription
        )
        if (result?.status) {
            resultFormSubmit?.(true, result?.message)
        } else {
            resultFormSubmit?.(false, result?.message)
        }
        pushLoading(false)

    }, 2000)



    //#region Thay đổi form rs 

    useEffect(() => {
        if (!isOpen) return

        if (vehicleId) {
            gInfoCarCustomer()
        }

        if (isProgrammaticCarLineSet.current) {
            isProgrammaticCarLineSet.current = false;
            return;
        }

        if (!vehicleId) {
            form.setFieldsValue({
                "numberPlateId": undefined,
                "chassisNo": undefined,
                "engineNo": undefined
            })

            setSLChassisNo([])
            setSLEngineNo([])
        }
        if (isOpen) {
            form.setFieldValue("numberPlateId", undefined); //rs  biển số xe
            form.setFieldValue("chassisNo", undefined); //rs Số khung (VIN)
            form.setFieldValue("engineNo", undefined); //rs bSố máy
        }
    }, [vehicleId]);

    useEffect(() => {
        if (!isOpen) return

        gSLEngineNo()
        if (isProgrammaticChassisNo.current) {
            isProgrammaticChassisNo.current = false;
            return;
        }
        if (isOpen) {
            form.setFieldValue("engineNo", undefined); //rs bSố máy
        }
    }, [chassisNo]); //Số khung (VIN)
    //#endregion

    useEffect(() => {
        if (isOpen)
            gSLCarId()
    }, [searchCar])

    useEffect(() => {
        if (!isOpen || !infoModalSalesAndService) return;
        isProgrammaticCarLineSet.current = true;
        isProgrammaticPlate.current = true;
        isProgrammaticChassisNo.current = true;

        const {
            adminId, adminName, branchId, branchName, carId, carName, chassisNo, contactType,
            currentMileageKm, engineNo, id, maintenanceReminderDate, plateNumber, plateNumberId,
            registrationDate, tentativeCustomerRequest, vehicleBookingDescription,
            vehicleBookingDocCode, vehicleId
        } = infoModalSalesAndService

        const registrationDateTmp = registrationDate ? dayjs(registrationDate, 'DD/MM/YYYY') : undefined
        const maintenanceReminderDateTmp = maintenanceReminderDate ? dayjs(maintenanceReminderDate, 'DD/MM/YYYY') : undefined

        form.setFieldsValue({
            vehicleBookingDocCode: mapDocCode(vehicleBookingDocCode),
            contactType: contactType,
            registrationDate: registrationDateTmp,
            vehicleId: vehicleId,
            numberPlateId: plateNumberId,
            chassisNo: chassisNo,
            engineNo: engineNo,

            currentMileageKm: currentMileageKm,
            maintenanceReminderDate: maintenanceReminderDateTmp,

            adminId: adminId,
            branchId: branchId,
            vehicleBookingDescription: vehicleBookingDescription,
        });
    }, [isOpen, infoModalSalesAndService]);

    useEffect(() => {
        if (isOpen) {
            if (!sLCarId.length)
                gSLCarId()
            if (!sLBranchId.length)
                gSLBranchId()

            form.setFieldsValue({
                adminId: id,
                branchId: unit,
                registrationDate: dayjs(),
            });
        } else {
            form.resetFields()
        }
    }, [isOpen])


    return (
        <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
        >
            <ConfigProvider locale={viVN}>
                <Modal
                    title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                        <span className="text-base text-344054 fw-500 font-medium">Chỉnh sửa chăm sóc bán hàng, dịch vụ</span>
                        <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
                    </div>}
                    open={isOpen}
                    onCancel={() => closeModal(false)}
                    centered
                    className="custom-modal-ant-history"
                    destroyOnClose
                    closeIcon={false}
                    footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
                        <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
                            <Button onClick={() => closeModal(false)}>Huỷ</Button>
                            <Button
                                type="primary"
                                onClick={() => form.submit()}
                            >Lưu</Button>
                        </div>
                    </div>}
                >
                    <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
                        <span className="text-base text-344054 fw-500 font-medium">Thông tin chung</span>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                layout="vertical"
                                label={<span>
                                    Loại tương tác <span className="text-FF1D1D">*</span>:
                                </span>}
                                name="vehicleBookingDocCode"
                                rules={[
                                    { required: true, message: "Vui lòng loại tương tác" },
                                ]}
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Loại tương tác"
                                    disabled
                                    options={dataInteractionCategory_V2}
                                />
                            </Form.Item>
                            <Form.Item
                                layout="vertical"
                                label="Phân loại liên hệ:"
                                name="contactType"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Phân loại liên hệ"
                                    options={dataInteractionCategory}
                                />
                            </Form.Item>
                        </div>
                        {/* Row 1 */}
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                layout="vertical"
                                label={
                                    <span>Ngày ghi nhận <span className="text-FF1D1D">*</span>:</span>
                                }
                                name="registrationDate"
                                rules={[
                                    { required: true, message: "Vui lòng ngày ghi nhận" },
                                ]}
                            >
                                <DatePicker
                                    className="w-full custom-input-date"
                                    format="DD/MM/YYYY"
                                />
                            </Form.Item>
                        </div>

                        <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin xe</span>
                        {/* Row 3 */}
                        <div className="grid grid-cols-2 gap-4">

                            {/* <Form.Item
                                layout="vertical" name='carId' hidden></Form.Item> */}
                            <Form.Item
                                layout="vertical"
                                label={<span>
                                    Tên xe <span className="text-FF1D1D">*</span>:
                                </span>}
                                name="vehicleId"
                                rules={[
                                    { required: true, message: "Vui lòng chọn tên xe" },
                                ]}
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Tên xe"
                                    showSearch
                                    searchValue={searchCar}
                                    onSearch={(e) => setSearchCar(e)}
                                    filterOption={false}
                                    allowClear
                                    options={sLCarId}
                                    onChange={(value, option: any) => {
                                        setCarId(option?.carId)
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                layout="vertical"
                                label="Biển số xe:"
                                name="numberPlateId"
                            >
                                <Input
                                    className="custom-page-css border rounded"
                                    placeholder="Biển số xe"
                                    disabled
                                />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                layout="vertical"
                                label="Số khung:"
                                name="chassisNo"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Số khung"
                                    disabled={!vehicleId}
                                    options={sLChassisNo}
                                />
                            </Form.Item>

                            <Form.Item
                                layout="vertical"
                                label="Số máy:"
                                name="engineNo"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Số máy"
                                    disabled={!chassisNo}
                                    options={sLEngineNo}
                                />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                layout="vertical"
                                label="Số KM hiện tại:"
                                name="currentMileageKm"
                            >
                                <InputNumber<number>
                                    className="w-full"
                                    // addonAfter="Km"
                                    controls={false}
                                    formatter={(value) =>
                                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                                    }
                                    parser={(value) =>
                                        value?.replace(/\./g, '') as unknown as number
                                    }
                                />
                            </Form.Item>

                            <Form.Item
                                layout="vertical"
                                label="Ngày nhắc BD 1000 km:"
                                name="maintenanceReminderDate"
                            >
                                <DatePicker
                                    className="w-full custom-input-date"
                                    format="DD/MM/YYYY"
                                    disabledDate={(current) =>
                                        current && current < dayjs().startOf('day')
                                    }
                                />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-4">


                            <Form.Item
                                layout="vertical"
                                label="Nhân viên tiếp nhận:"
                                name="adminId"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Nhân viên tiếp nhận"
                                    options={sLAdminId}
                                />
                            </Form.Item>

                            <Form.Item
                                layout="vertical"
                                label="Đơn vị:"
                                name="branchId"
                            >
                                <Select
                                    className="custom-page-css border rounded"
                                    placeholder="Đơn vị"
                                    options={sLBranchId}
                                />
                            </Form.Item>
                        </div>
                        <Form.Item
                            layout="vertical"
                            label="Nội dung:"
                            name="vehicleBookingDescription"
                        >
                            <TextArea
                                rows={4}
                                placeholder="Nhập nội dung"
                            />
                        </Form.Item>

                    </div>
                </Modal>
            </ConfigProvider>
        </Form>
    )
}
export default ModalSalesAndServiceUpdate
